import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  subtitle: {
    fontWeight: 'bold',
  },
  text: {
    marginTop: '0.5rem',
  },
  qrcode: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: 32,
      justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: '2rem',
      flexDirection: 'column',
    },
  },
}));
